<template>
  <a-modal
    title="HR信息"
    okText="编辑"
    @ok="save"
    v-model="visible"
    :width="650"
    class="showMessage"
  >
    <template
      v-if="
        !!allDetail &&
          !!allDetail.contacter &&
          !!allDetail.ie_user &&
          !!allDetail.report_data
      "
    >
      <div class="listtitle">基本信息</div>
      <a-row class="row-content" type="flex" justify="start" align="middle">
        <a-col class="col">
          <span class="title">姓名：{{ allDetail.contacter.hr_name }}</span>
        </a-col>
        <a-col class="col">
          <span class="title"
            >所属公司：{{ allDetail.contacter.hr_company_name }}</span
          >
        </a-col>
        <a-col class="col">
          <span class="title">电话：{{ allDetail.contacter.hr_mobile }}</span>
        </a-col>
        <a-col class="col">
          <span class="title"
            >职位title：{{ allDetail.contacter.hr_title }}</span
          >
        </a-col>
        <a-col class="col">
          <span class="title">座机：{{ allDetail.contacter.hr_landline }}</span>
        </a-col>
        <a-col class="col">
          <span class="title">邮箱：{{ allDetail.contacter.hr_email }}</span>
        </a-col>
      </a-row>
      <div class="listtitle">建档信息</div>
      <a-row class="row-content" type="flex" justify="start" align="middle">
        <a-col class="col">
          <span class="title">建档人：{{ allDetail.ie_user.name }}</span>
        </a-col>
        <a-col class="col">
          <span class="title"
            >建档时间：{{ allDetail.ie_user.timeCreated }}</span
          >
        </a-col>
        <a-col class="col">
          <span class="title">建档人电话：{{ allDetail.ie_user.tel }}</span>
        </a-col>
      </a-row>
      <div class="listtitle">招聘信息</div>
      <a-row class="row-content" type="flex" justify="start" align="middle">
        <a-col class="col">
          <span class="title"
            >关联职位数：<span class="active">{{
              allDetail.report_data.job_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >招聘中职位数：<span class="active">{{
              allDetail.report_data.job_processing_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >职位做单数：<span class="active">{{
              allDetail.report_data.entry_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >职位成单数：<span class="active">{{
              allDetail.report_data.complete_count
            }}</span></span
          >
        </a-col>
      </a-row>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: "ShowMessage",
  props: {
    allDetail: {
      type: Object,
      default: () => {
        {
        }
      }
    },
    callback: {
      type: Function
    },
    record: {
      type: Object
    }
  },

  data() {
    return {
      // record: "",
      visible: false
    };
  },
  methods: {
    save() {
      this.visible = false;
      this.callback && this.callback(this.record);
    },
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.showMessage {
  .ant-modal-title {
    text-align: center;
  }
  .listtitle {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .row-content {
    margin-left: 10px;
    .col {
      width: 50%;
      margin-bottom: 10px;
      .active {
        color: #35b5fe;
      }
    }
  }
}
</style>
